export class BranchStatusLogFilterEntity {
  id!: number
  page?: number
  limit?: number
}
